<template>
    <!-- TODO: Better Desktop implementation  -->
    <div id="home-container">
        <div id="landing">
            <div id="page-title">
                <v-avatar id="ofb-avatar" size="100">
                    <img src="../assets/openbb_logo.png" alt="ofb">
                </v-avatar>
                <h1>The Only Finance Bot You'll Ever Need</h1>
                <p style="color:#dc144d"> Slash Commands are here! (thanks Discord) <a href="https://support.discord.com/hc/en-us/articles/1500000368501-Slash-Commands-FAQ#:~:text=WHAT%20ARE%20SLASH%20COMMANDS%3F,to%20use%20your%20favorite%20bot.">here!</a> </p>
                <p> </p>
                <p style="color:crimson"> OFB has joined forces with OpenBB - Read more <a href=" https://openbb.co/blog/optionsfambot-announcement">here!</a> </p>
            </div>

            <div id="button-container">
                <v-btn
                    large
                    class="ma-2 white--text"
                    id="discord-button"
                    v-on:click="addToDiscord()"
                >
                    Add to Discord
                    <img class="right-side-button-icon" src="../assets/Discord-Logo-White.svg" alt="Discord Logo">
                </v-btn>
                <v-btn
                        large
                        class="ma-2 white--text"
                        id="prem-button"
                        v-on:click="showLogin()"
                        v-if="true"
                >
                    Go Premium (OpenBB)
                    <img id="prem" src="../assets/ofbsvg.svg" alt="OFB Logo">
                </v-btn>
                <v-btn
                    large
                    class="ma-2 white--text"
                    id="slack-button"

                    v-if="newUpdate"
                >
                    Add to Slack
                    <img id="slack-is-annoying" src="../assets/Slack_Mark_Fixed.svg" alt="Slack Logo">
                </v-btn>
                <v-btn
                        large
                        class="ma-2 white--text"
                        id="join-OFB-discord-button"
                        v-on:click="joinOFBDiscord()"
                >
                    Join OFB Discord!
                    <img class="right-side-button-icon" src="../assets/Discord-Logo-White.svg" alt="Discord Logo">
                </v-btn>
                <v-btn
                        large
                        class="ma-2 white--text"
                        id="server-button"
                        v-on:click="showServers()"
                >
                    Server List
                    <v-icon class="right-side-button-icon">mdi-server</v-icon>
                </v-btn>


                <div id="action-buttons">
                    <v-btn
                            large
                            class="ma-2 white--text"
                            id="commands-button"
                            v-on:click="showCommands()"
                    >
                        Commands
                    </v-btn>

                    <v-btn
                            large
                            class="ma-2 white--text"
                            id="features-button"
                            v-on:click="showFeatures()"
                    >
                        OpenBB
                    </v-btn>
                </div>

            </div>
            <a href="https://iexcloud.io">Data provided by IEX Cloud</a>
        </div>

<!--        <Features/>-->

    </div>

</template>


<script>
//import Features from "./Features";

// Auto scrolling
// let isScrolling = false
// let scrollIndex = 0
// let scrollReferences = [
//     "#landing",
//     "#flow",
//     "#darkpool",
//     "#options",
//     "#futures",
//     "#charting",
// ]

export default {
    name: 'Home',

    props: {
    },

    mounted() {
        window.scrollTo(0,0);
    },

    created () {
        window.addEventListener('wheel', this.handleScroll, { passive: false });
    },
    destroyed () {
        window.removeEventListener('wheel', this.handleScroll);
    },

    // components: {
    //     Features
    // },

    methods: {
        addToDiscord: function () {
            let win = window.open("https://discord.com/api/oauth2/authorize?client_id=452988914215550997&permissions=397888842817&scope=bot%20applications.commands", '_blank');
            win.focus();
        },
        joinOFBDiscord: function () {
            let win = window.open("https://discord.gg/SpuDKjkJ7T", '_blank');
            win.focus();
        },

        showCommands: function() {
            //this.$router.push({name: "Commands"});
            window.open("https://my.openbb.co/app/bot/commands", '_blank');
        },

        showServers: function() {
            this.$router.push({name: "Servers"});
        },

        showLogin: function() {
            window.open("https://my.openbb.co/register", '_blank');
            //this.$router.push({name: "Login"});
        },

        showFeatures: function () {
            window.open("https://openbb.co/", '_blank');
         },

        // handleScroll: function (event) {
        //     event.preventDefault()
        //     event.stopImmediatePropagation()
        //
        //     if (isScrolling){
        //         return
        //     } else {
        //         isScrolling = true
        //     }
        //
        //     if (event.deltaY < 0) {
        //         this.scrollUp()
        //     } else if (event.deltaY > 0) {
        //         this.scrollDown()
        //     }
        //
        // },

        // scrollUp: function () {
        //     if (scrollIndex > 0 ) {
        //         scrollIndex--
        //     } else {
        //         scrollIndex = scrollReferences.length - 1
        //     }
        //
        //     this.$vuetify.goTo(scrollReferences[scrollIndex], {
        //         duration: 850,
        //         easing: "easeInOutCubic",
        //     }).then(function () {
        //         isScrolling = false
        //     })
        // },

        // scrollDown: function () {
        //     if (scrollIndex < scrollReferences.length - 1){
        //         scrollIndex++
        //     } else {
        //         scrollIndex = 0
        //     }
        //
        //     this.$vuetify.goTo(scrollReferences[scrollIndex], {
        //         duration: 850,
        //         easing: "easeInOutCubic",
        //     }).then(function () {
        //         isScrolling = false
        //     })
        // }
    },

    data: () => ({
        newUpdate: false,
    }),
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    html {
        background-color: #292929;
    }

    #ofb-avatar{
        display:block;
        margin-left: auto;
        margin-right: auto;
    }

    #home-container {
        height: auto;
        width: 100%;
        padding: 20px 20px 10px 20px;
        background-color: #292929;
    }

    #landing {
        height: calc(100vh - 5rem);
        display: flex;
        flex-direction: column;

        padding-top: 1rem;
        justify-content: flex-start;
        align-items: center;
    }

    h1 {
        font-size: 35px;
        font-weight: bold;
        text-align: center;
        color: #FFFFFF;
    }

    p {
        text-align: center;
        font-size: 22px;
        color: #bebebe;
    }
    
    #button-container {
        display: grid;
        align-self: start;
        align-items: start;
        grid-template-rows: fit-content(1em) fit-content(1em) fit-content(1em);

        height: auto;
        width: 100%;
        margin-top: 15px;
    }

    #discord-button {
        position: relative;
        height: 52px;
        background-color: #7289DA;        
    }

    #server-button {
        position: relative;
        height: 52px;
        background-color: #404040;
    }

    #slack-button {
        height: 52px;
        background-color: #4A154B;
    }

    #prem-button {
        height: 52px;
        background-color: #15454b;
    }

    #commands-button {
        height: 52px;
        background-color: #404040;
    }

    #join-OFB-discord-button {
        height: 52px;
        background-color: #404040;
    }

    #features-button {
        height: 52px;
        background-color: #404040;
    }

    #slack-is-annoying {
        position: absolute;
        height: 25px;
        right: 0;
    }

    #prem {
        position: absolute;
        height: 25px;
        right: 0;
    }

    .right-side-button-icon {
        position: absolute;
        height: 30px;
        right: 0;
    }

    #action-buttons {
        display: flex;
        flex-direction: column;
    }

    @media screen and (min-width: 750px) {

        #home-container {
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            overflow: hidden;
        }

        #landing {
            height: 100vh;
            display: flex;
            flex-direction: column;

            justify-content: center;
            align-items: center;
        }

        h1 {
            font-size: 45px;
        }

        p {
            font-size: 30px;
        }

        #page-title {
            max-width: 775px;
        }

        #button-container {
            width: 50%;
            align-self: center;
            max-width: 450px;

        }

        #action-buttons {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }

        #commands-button {
            width: 45%;
        }

        #features-button {
            width: 45%;
        }
    }
    

</style>
